import { erc20Abi, erc721Abi, erc1155Abi, starsVestingSwapAbi, starsV2Abi, mogulBuyAbi } from './abi';
import { Chains, ContractsNames, IContracts } from './types';

export const NATIVE_ADDRESS_CHECKSUM = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';

export const nativeAddressesChecksum = {
  [Chains.Ethereum]: NATIVE_ADDRESS_CHECKSUM,
  [Chains.BSC]: NATIVE_ADDRESS_CHECKSUM,
};

export const contracts: IContracts['contracts'] = {
  [ContractsNames.StarsV1]: {
    testnet: {
      address: {
        [Chains.Ethereum]: '0xA3196f5364662fCc08802d4d4bB6Bb8EB92A74E9',
        [Chains.BSC]: '0x6a9CCC23099bFd68dF3E86DD3dba2ccC4a883CA9',
      },
      abi: erc20Abi,
    },
    mainnet: {
      address: {
        [Chains.Ethereum]: '0xc55c2175E90A46602fD42e931f62B3Acc1A013Ca',
        [Chains.BSC]: '0xbD83010eB60F12112908774998F65761cf9f6f9a',
      },
      abi: erc20Abi,
    },
  },
  [ContractsNames.StarsV2]: {
    testnet: {
      address: {
        [Chains.Ethereum]: '0xdbf0B64A089895877370BDaF2BD159400dA306F7',
        [Chains.BSC]: '0xa2cC9a802b3355D80A3c0DdcC955B1015edE0393',
      },
      abi: starsV2Abi,
    },
    mainnet: {
      address: {
        [Chains.Ethereum]: '0x88fd59e1DD3715A98bb66149DA9c944d9E795c12',
        [Chains.BSC]: '0x88fd59e1DD3715A98bb66149DA9c944d9E795c12',
      },
      abi: starsV2Abi,
    },
  },
  [ContractsNames.StarsVestingSwap]: {
    testnet: {
      address: {
        [Chains.Ethereum]: '0x928724290F7F868C2fEe10720aE5b48C94c5139F',
        [Chains.BSC]: '0x4D9b76704ace001f1Ce6BD250Dd0Cf358BF7Bb52',
      },
      abi: starsVestingSwapAbi,
    },
    mainnet: {
      address: {
        [Chains.Ethereum]: '0xa19294AeDC27BfE1592d18Fd84b3A708327B44C1',
        [Chains.BSC]: '0x0c0D7E8FBBFc38fAD7D1113C2e070AC416774185',
      },
      abi: starsVestingSwapAbi,
    },
  },
  [ContractsNames.Stars721]: {
    testnet: {
      address: {
        [Chains.Ethereum]: '0x502c11C15BF18F3CCE7b5df54A8D85DdAAe35e2F',
        [Chains.BSC]: '0x74aD5937bd650040414D456236BA6a48bcb2868C',
      },
      abi: erc721Abi,
    },
    mainnet: {
      address: {
        [Chains.Ethereum]: '0x761317D378FB401829ecA5513189F7F91F122444',
        [Chains.BSC]: '0x761317D378FB401829ecA5513189F7F91F122444',
      },
      abi: erc721Abi,
    },
  },
  [ContractsNames.Stars1155]: {
    testnet: {
      address: {
        [Chains.Ethereum]: '0xC316540F293726adaEF41093A32469D740D99aAc',
        [Chains.BSC]: '0xec463F41Ebf630939F9a46f41fB8CB9882cc6406',
      },
      abi: erc1155Abi,
    },
    mainnet: {
      address: {
        [Chains.Ethereum]: '0x07BFB924F29Fc02f4A92E608bBFf4d63ee9ceF89',
        [Chains.BSC]: '0x07BFB924F29Fc02f4A92E608bBFf4d63ee9ceF89',
      },
      abi: erc1155Abi,
    },
  },
  [ContractsNames.MogulBuy]: {
    testnet: {
      address: {
        [Chains.Ethereum]: '0xF47b96c3917EEa571CA1ECDA4b5D9F99EF6d9E85',
        [Chains.BSC]: '0x6Fc0353693DBe1337196E53f48F39B81A7bb61b2',
      },
      abi: mogulBuyAbi,
    },
    mainnet: {
      address: {
        [Chains.Ethereum]: '0x99F7BC0135771468b4d49164f7F8b9571ECcc2b4',
        [Chains.BSC]: '0x898d9608CbE49AA63AeD7e1d9F8f9eA91765Ab1c',
      },
      abi: mogulBuyAbi,
    },
  },
  [ContractsNames.NativeToken]: {
    testnet: {
      address: nativeAddressesChecksum,
      abi: [],
    },
    mainnet: {
      address: nativeAddressesChecksum,
      abi: [],
    },
  },
  [ContractsNames.USDTToken]: {
    testnet: {
      address: {
        [Chains.Ethereum]: '0xA3e450857052f24357CeeC0a64b8a45BBE5f0725',
        [Chains.BSC]: '0x6BDA20b2aDb8c225fCC2cCDe651180344E705E29',
      },
      abi: erc20Abi,
    },
    mainnet: {
      address: {
        [Chains.Ethereum]: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        [Chains.BSC]: '0x55d398326f99059fF775485246999027B3197955',
      },
      abi: erc20Abi,
    },
  },
};

export const contractsConfig: IContracts = {
  names: Object.keys(ContractsNames),
  decimals: 18,
  contracts,
};
